import { Controller } from "@hotwired/stimulus"

// The app shell's sidebar. JS only flips the collapsed attribute — the
// motion lives entirely in CSS (docs/frontend.md). The cookie lets the
// server render the next page already in the chosen state, so Turbo
// visits never flash or replay the animation.
export default class extends Controller {
  toggle() {
    const collapsed = this.element.toggleAttribute("data-sidebar-collapsed")
    document.cookie = `sidebar_collapsed=${collapsed}; path=/; max-age=31536000; samesite=lax`
  }
}
